export const BRAND_FULL = "Ellyanna - Salon Booking and Intelligence Network";
export const BRAND_SHORT = "Ellyanna";
export const BRAND_SUBTITLE = "Salon Booking and Intelligence Network";
export { default as BRAND_WORDMARK } from "../assets/branding/ellyanna_logo_cropped_transparent.png";
export { default as BRAND_ICON } from "../assets/branding/ellyanna_icon_only.png";
export { default as BRAND_WORDMARK_TEXT } from "../assets/branding/ellyanna_wordmark_text.png";
